<template>
  <div class="modal fade" id="gallyerModal" tabindex="-1" role="dialog" aria-labelledby="gallyerModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="gallyerModalLabel">Gallery</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group" v-if="posDocuments.length">
            <label class="custom-label">Communication on POS</label>
            <br>
            <div class="row">
              <div class="col-sm-4 text-center" v-for="doc in posDocuments">
                <gallery-thumb :file="doc.path" :description="doc.communication" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="smDocuments.length">
            <label class="custom-label">Communication on Social Media</label>
            <br>
            <div class="row">
              <div class="col-sm-4 text-center" v-for="doc in smDocuments">
                <gallery-thumb :file="doc.path" :description="doc.communication" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="kaDocuments.length">
            <label class="custom-label">Communication from Key Account</label>
            <br>
            <div class="row">
              <div class="col-sm-4 text-center" v-for="doc in kaDocuments">
                <gallery-thumb :file="doc.path" :description="doc.communication" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="promoDocuments.length">
            <label class="custom-label">Promotion during test</label>
            <br>
            <div class="row">
              <div class="col-sm-4 text-center" v-for="doc in promoDocuments">
                <gallery-thumb :file="doc.path" :description="doc.promo" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="trial.general_documents.length || trial.general_documents_folders.length">
            <label class="custom-label">General Store Pictures</label>
            <div v-for="(folder, index) in trial.general_documents_folders">
              <template v-if="folder.documents.length">
                <br v-if="index !== 0">
                <p><i class="fa fa-folder"></i> {{ folder.name }}</p>
                <div class="row">
                  <div class="col-sm-4 text-center" v-for="doc in folder.documents">
                    <gallery-thumb :file="doc.path" :description="doc.promo" />
                  </div>
                </div>
              </template>
              <hr v-if="index === (trial.general_documents_folders.length - 1)">
            </div>
            <div class="row">
              <div class="col-sm-4 text-center" v-for="doc in trial.general_documents">
                <gallery-thumb :file="doc.path" :description="doc.promo" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="rollOutPromotions.length">
            <label class="custom-label">Roll Out Promotions</label>
            <br>
            <div class="row">
              <div class="col-sm-4 text-center" v-for="doc in rollOutPromotions">
                <gallery-thumb :file="doc.path" :description="doc.promo" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      trial: null,
      type: {
        default: 'trial',
      },
    },
    methods: {
      communicationhasDocuments(communications, id) {
        const existingCom = communications.find(communication => communication.id === id)
        return existingCom ? existingCom.documents.length : false
      },
      sortByCreatedAt(a, b) {
        if (a.created_at < b.created_at) {
          return 1
        }
        if (a.created_at > b.created_at) {
          return -1
        }
        return 0
      }
    },
    computed: {
      posDocuments() {
        return this.trial.pos_communications.reduce((documents, communication) => {
          return documents.concat(communication.documents.map(doc => {
            doc.communication = communication.name
            return doc
          }))
        }, []).sort(this.sortByCreatedAt)
      },
      smDocuments() {
        return this.trial.social_media_communications.reduce((documents, communication) => {
          return documents.concat(communication.documents.map(doc => {
            doc.communication = communication.name
            return doc
          }))
        }, []).sort(this.sortByCreatedAt)
      },
      kaDocuments() {
        return this.trial.key_account_communications.reduce((documents, communication) => {
          return documents.concat(communication.documents.map(doc => {
            doc.communication = communication.name
            return doc
          }))
        }, []).sort(this.sortByCreatedAt)
      },
      promoDocuments() {
        if (this.type !== 'trial') return []

        return this.trial.promos.reduce((documents, promo) => {
          return documents.concat(promo.documents.map(doc => {
            doc.promo = promo.name
            return doc
          }))
        }, []).sort(this.sortByCreatedAt)
      },
      rollOutPromotions() {
        if (this.type === 'trial') return []

        return this.trial.roll_out_promotions.reduce((documents, promo) => {
          return documents.concat(promo.documents.map(doc => {
            doc.promo = promo.name
            return doc
          }))
        }, []).sort(this.sortByCreatedAt)
      },
    }
  }
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.fa-folder {
  color: $kodak-red;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/GalleryModal.vue